<template>
  <div>
    <!-- Hero Banner Start -->
    <hero-banner-one></hero-banner-one>
    <!-- Hero Banner End -->

    <!-- Feature Area Start -->
    <feature-area></feature-area>
    <!-- Feature Area End -->

    <!-- Product Banner Area Start -->
    <product-banner-area></product-banner-area>
    <!-- Product Banner Area End -->

    <!-- Top Products Start -->
    <product-home-top-products></product-home-top-products>
    <!-- Top Products End -->

    <!-- Product Banner Two Start -->
    <product-banner-two></product-banner-two>
    <!-- Product Banner Two End -->

    <!-- All Products Start -->
    <product-home-all-products></product-home-all-products>
    <!-- All Products End -->

    <!-- Feature Products Start -->
    <product-home-feature-products></product-home-feature-products>
    <!-- Feature Products End -->

    <!-- Moving Text Area Start -->
    <moving-text-area></moving-text-area>
    <!-- Moving Text Area End -->

    <!-- Product Banner Three Start -->
    <product-banner-area-three></product-banner-area-three>
    <!-- Product Banner Three End -->

    <!-- Recommended Products Start -->
    <product-home-recommend-products></product-home-recommend-products>
    <!-- Recommended Products End -->

    <!-- Brand Area Start -->
    <brand-area></brand-area>
    <!-- Brand Area End -->

    <!-- CTA Area Start -->
    <cta-area></cta-area>
    <!-- CTA Area End -->
  </div>
</template>



<script>
//import HeroBannerOne from '@/components/hero-banner/hero-banner-one.vue';
import FeatureArea from '@/components/feature/feature-area.vue';
import ProductBannerArea from '@/components/product/banner/product-banner-area.vue';
//import ProductHomeTopProducts from '@/components/product/home/top-products.vue';
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Home",
    components: {
      //HeroBannerOne,
      ProductBannerArea,
      FeatureArea,
      //ProductHomeTopProducts
    },
  };
  </script>
  
  <style scoped>
  /* Add styles for Home page */
  </style>
  